import React from "react";
import "./video.scss";
import { useEffect } from "react";
import {motion} from "framer-motion";
import {AWS_S3_BUCKET} from "../../../global_vars";
import {useNavigate} from "react-router-dom";

function VideoSection() {

    const texts = [
      "Award-Winning Broker Partnerships",
      "Over 5 Billion AED in Sales",
      "U.S. to Dubai Investment Expertise",
      "Tailored Investment Solutions"
    ];

    const [index, setIndex] = React.useState(0);

    const navigate = useNavigate();

    const navigateToURL = (url: string) => {
        navigate(`/${url}`);
    }

    const videoURL = `${AWS_S3_BUCKET}/main_video.MP4`;

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex(index => (index + 1)%texts.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [texts.length]);


    return (
        <div style={{position: "relative"}}>
            <video src={videoURL} className={"video-main"}
            playsInline={true} 
            muted={true} 
            loop={true} 
            autoPlay={true} preload={"auto"} />
            <div className={"video-desc"}>
                <div className={"video-content"}>
                    <motion.h2
                      key={index}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 20 }}
                      transition={{ duration: 2 }}
                      style={{padding: 0, margin: 0}}
                    >
                        <h5 className={"company-values"}>
                            {texts[index]}
                        </h5>
                    </motion.h2>
                    <h1 className={"company-name"}>
                        LUXORA DUBAI
                    </h1>
                    <h4 className={"caption"}>
                    BRINGING DUBAI'S FINEST TO YOU
                    </h4>
                    <button className={"explore-properties"} onClick={() => {navigateToURL("property/list")}}>
                        EXPLORE PROPERTIES
                    </button>
                </div>
            </div>
        </div>
    )
}

export default VideoSection;